import { Address } from "viem"

import { ONE_MINUTE_IN_SECONDS, ONE_SECOND_IN_MILLISECONDS } from "../constants"
import { PoolFactory } from "../constants/artifacts"
import { SwappableToken, SwapRoute } from "../types"

import { multiplyBigIntWithDecimal } from "./numbers"
import { isStablecoin } from "./token"

export const getSwapRoutes = (
  tokenInAddress: Address | null,
  tokenOutAddress: Address | null,
  stable: boolean,
): SwapRoute[] => {
  if (!tokenInAddress || !tokenOutAddress) return []

  return [
    {
      from: tokenInAddress,
      to: tokenOutAddress,
      stable,
      factory: PoolFactory.address,
    },
  ]
}

export const getSwapMinAmountOut = (amount: bigint, slippage: number) => {
  const slippageAllowance = 1 - slippage / 100

  return multiplyBigIntWithDecimal(amount, slippageAllowance)
}

export const getSwapDeadline = () => {
  const now = Date.now()

  // Deadline set to 5 minutes from now
  const fiveMinutesFromNow =
    now + ONE_MINUTE_IN_SECONDS * 5 * ONE_SECOND_IN_MILLISECONDS

  // Need to multiply by 1000 to match on-chain format
  return BigInt(fiveMinutesFromNow) * 1000n
}

export const isStablePool = (token0: SwappableToken, token1: SwappableToken) =>
  isStablecoin(token0) && isStablecoin(token1)
